import { useCallback } from "react";
import { useStores } from "../../../../stores/setup/use-store";

export function useDashboardSelection() {
	const {
		dataStores: {
			operationRuleStore,
			operationRuleLocationStore,
			operationRuleLocationInsightStore,
			oceanWeatherIntelligenceStore,
		},
	} = useStores();

	const handleSelectDashboardChange = useCallback(
		(value: number) => {
			if (value) {
				operationRuleLocationStore.setOperationRuleLocationMainId(value);
				operationRuleStore.setOperationRuleMain(value);
				operationRuleLocationStore.getOperationRuleLocationsApi(value);
				operationRuleLocationInsightStore.setHasInsights(true);

				if (operationRuleLocationStore.operationRuleLocationMainId > 0) {
					operationRuleLocationInsightStore.getOperationRuleLocationInsightApi(
						operationRuleLocationStore.operationRuleLocationMainId
					);
				} else {
					operationRuleLocationInsightStore.setOperationRuleLocationItens([]);
				}

				oceanWeatherIntelligenceStore.setChangeForUpdate({
					update: true,
					expiration: 0,
				});
			}
		},
		[
			operationRuleStore,
			operationRuleLocationStore,
			operationRuleLocationInsightStore,
			oceanWeatherIntelligenceStore,
		]
	);

	return {
		handleSelectDashboardChange,
	};
}
